<div
  role="button"
  class="solo-card"
  [class.disabled]="disabled()"
  [ngStyle]="cardStyles | theme"
  [attr.tabindex]="disabled() ? -1 : 0"
  [attr.aria-disabled]="disabled()"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  (keydown.space)="onClick()"
  *transloco="let t; prefix: 'components.solo'"
>
  @if (splicedBg) {
    <app-spliced-background
      [image]="splicedBg.imageUrl"
      [cornerSize]="splicedBg.cornerSize"
      [disabled]="disabled()"
    />
  }
  <div class="beat" [ngStyle]="beatStyles | theme">
    <app-icon
      icon="target"
      colorCss="--card-solo-label-beat-fill"
      sizeCss="--card-solo-label-beat-icon-size"
    />
    <span>{{ t("outscore") }}</span>
  </div>

  <div class="stats">
    <app-solo-stat tokens="card-solo-stat" [label]="t('target')">
      <div class="target-line">
        <span class="target" [ngStyle]="targetStyles | theme">{{ target() }}</span>
        <span [ngStyle]="unitStyles | theme">{{ t("points-unit") }}</span>
      </div>
    </app-solo-stat>
    <app-solo-stat tokens="card-solo-stat" [label]="t('max-prize')">
      <app-currency-amount
        [primaryAmount]="maxPrize().primary"
        [secondaryAmount]="maxPrize().secondary"
        [amountStyles]="statPrizeStyles"
      />
    </app-solo-stat>
    <app-solo-stat tokens="card-solo-stat" [label]="t('min-entry')">
      <app-currency-amount
        [primaryAmount]="minEntry().primary"
        [secondaryAmount]="minEntry().secondary"
        [amountStyles]="statValueStyles"
      />
    </app-solo-stat>
  </div>

  <p class="cta" [ngStyle]="ctaStyles | theme">
    <span>{{ cta().before }}</span
    ><span [ngStyle]="ctaMultiplierStyles | theme">{{ cta().figure }}</span
    ><span>{{ cta().after }}</span>
  </p>

  <!-- Inert: the whole card is the tap target, so the button only shows where to tap. A live
       button inside it would be a second tab stop and fire the card's click twice. -->
  <app-button
    inert
    class="play-button"
    [label]="t('select-prize')"
    variant="primary"
    stretch="fill"
    [disabled]="disabled()"
  />
</div>
